/* Jaypee motion layer: scroll progress, header state, staggered reveals, count-up numbers.
   Progressive enhancement only: without JS, or with reduced motion, everything is simply visible. */
(function () {
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var bar = null;
  if (!reduce) {
    bar = d.createElement('div');
    bar.className = 'scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset || 0;
      root.classList.toggle('is-scrolled', y > 8);
      if (bar) {
        var h = root.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
      }
      ticking = false;
    });
  }

  var HEADINGS = '.fb-eyebrow, .fb-heading, .fb-lead, [class*="__caption"], [class*="__heading"], [class*="__subheading"], [class*="__header"] > *';
  var ITEMS = '[class*="__grid"] > *, [class*="__item"], [class*="__card"], [class*="__stage"], [class*="__pillar"], [class*="__column"], [class*="__row"], [class*="__stat"], [class*="__tab"], .grid > *, .rte > *';
  var SKIP = '[data-animate], header, footer, dialog, nav, [class*="drawer"], [class*="hero-show"], [class*="__track"] > *, [class*="slideshow"], [class*="announcement"], [class*="breadcrumb"], .section-heading, .page-header__breadcrumbs, .product-card, .card';

  function tagReveals() {
    var sections = d.querySelectorAll('#MainContent > .shopify-section');
    sections.forEach(function (section, si) {
      if (si === 0 && section.querySelector('hero-show, .slideshow, [class*="banner"]')) return;
      var tagged = [];
      section.querySelectorAll(HEADINGS + ',' + ITEMS).forEach(function (el) {
        if (el.matches(SKIP) || el.closest(SKIP)) return;
        if (el.closest('[data-reveal]')) return;
        for (var i = 0; i < tagged.length; i++) { if (tagged[i].contains(el)) return; }
        tagged.push(el);
      });
      var perParent = new Map();
      tagged.forEach(function (el) {
        var p = el.parentElement;
        var n = perParent.get(p) || 0;
        perParent.set(p, n + 1);
        el.setAttribute('data-reveal', el.matches('[class*="__stat"], [class*="__card"], [class*="__item"]') ? 'scale' : '');
        el.style.setProperty('--reveal-delay', Math.min(n, 6) * 90 + 'ms');
      });
    });
  }

  function countUp(el) {
    var m = /^(\d{1,3})(\D*)$/.exec(el.textContent.trim());
    if (!m) return;
    var target = parseInt(m[1], 10), suffix = m[2], start = null, dur = 1300;
    el.textContent = '0' + suffix;
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init() {
    if (bar) { d.body.appendChild(bar); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('reveal-on');
    tagReveals();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    d.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

    var counters = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countUp(entry.target);
        counters.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    d.querySelectorAll('.brand-statement__stat-value, .statistics__value').forEach(function (el) { counters.observe(el); });

    /* Safety net: never leave content hidden if an observer misses it */
    setTimeout(function () {
      d.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 2500);
  }

  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})();